<template>
    <div class="w-full">
        <div class="w-full mx-auto mt-20">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    JADWAL DOKTER KHUSUS - EDIT
                </h1>
            </div>
            <div class="w-full">
                <p class=" font-poppins font-bold text-center text-xl">Tanggal Periksa: {{ hari.keterangan }}</p>
                <form @submit.prevent="update">
                    <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                        <SelectInput
                            v-model="form.poli"
                            :error="form.errors.poli"
                            id="poli"
                            label="poli"
                            class="w-full md:w-auto grow"
                            disabled="disabled"
                        >
                            <option value="">=== PILIH POLI ===</option>
                            <option
                                v-for="poli in poli"
                                :key="poli.FS_KD_LAYANAN"
                                :value="poli.FS_KD_LAYANAN"
                            >
                                {{ poli.FS_NM_LAYANAN }}
                            </option>
                        </SelectInput>
                        <SelectInput
                            v-model="form.dokter"
                            :error="form.errors.dokter"
                            id="dokter"
                            label="dokter"
                            class="w-full md:w-auto md:mx-2 grow"
                            disabled="disabled"
                        >
                            <option value="">=== PILIH DOKTER ===</option>
                            <option
                                v-for="dokter in dokter"
                                :key="dokter.FS_KD_PEG"
                                :value="dokter.FS_KD_PEG"
                            >
                                {{ dokter.FS_NM_PEG }}
                            </option>
                        </SelectInput>
                        <TimeInput
                            v-model="form.jamMulai"
                            :error="form.errors.jamMulai"
                            class="w-full mt-2"
                            id="jam_mulai"
                            label="Jam Mulai Praktik"
                            type="text"
                            :disabled="jamMulaiDisabled"
                        />
                        <div class="flex justify-center">
                            <div class="mt-2 mr-5">
                                <label class="form-label">Libur</label>
                                <input type="radio" :value="libur" v-model="pickStatus">
                            </div>
                            <div class="mt-2">
                                <label class="form-label">Operasi</label>
                                <input type="radio" :value="operasi" v-model="pickStatus">
                            </div>
                        </div>
                        <TimeInput
                            v-model="form.jamSelesai"
                            :error="form.errors.jamSelesai"
                            class="w-full mt-2"
                            id="jam_selesai"
                            label="Jam Selesai Praktik"
                            type="text"
                            :disabled="jamSelesaiDisabled"
                        />
                        <div class="flex justify-center">
                            <div class="mt-2 mr-5">
                                <label class="form-label">Selesai</label>
                                <input type="radio" :value="selesai" v-model="pickStatus">
                            </div>
                            <div class="mt-2">
                                <label class="form-label">Pilih</label>
                                <input type="radio" :value="pilih" v-model="pickStatus">
                            </div>
                        </div>
                        <div class="w-full mt-5">
                            <hr class="mt-5" />
                        </div>
                        <div class="mt-2 w-full text-right">
                            <p class="text-xs font-poppins">* Apabila selesai dicek maka input Jam Selesai Praktik akan disable</p>
                        </div>
                    </div>
                    <div class="w-full flex justify-center items-center">
                        <button
                            @click.prevent="destroy"
                            class="btn-red h-16 rounded-3xl mt-8 text-white mx-2 o w-1/2"
                        >
                            Hapus Jadwal Dokter Khusus
                        </button>
                        <button
                            type="submit"
                            class="bg-teal-400 hover:bg-teal-700 h-16 rounded-3xl mt-8 text-white m-auto w-1/2"
                        >
                            Simpan Jadwal Dokter Khusus
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <FlashMessage class="mt-5 w-1/2 m-auto" />
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import SelectInput from "../../../Shared/SelectInput.vue";
import TimeInput from "../../../Shared/TimeInput.vue";
import TextInput from "../../../Shared/TextInput.vue";
import LayoutAdmin from "../../../Shared/LayoutAdmin.vue";
import FlashMessage from "../../../Shared/FlashMessage.vue";
export default {
    data() {
        return {
            form: this.$inertia.form({
                poli: this.jadwalDokterKhusus.FS_KD_LAYANAN,
                dokter: this.jadwalDokterKhusus.FS_KD_DOKTER,
                hari: this.hari.kode,
                tglPeriksa: this.hari.tgl,
                jamMulai: this.getInitialState().initialJamMulai,
                jamSelesai: this.getInitialState().initialJamSelesai,
                status: this.jadwalDokterKhusus.FS_STATUS
            }),
            pickStatus: this.getInitialState().initialPickStatus,
            libur: 'libur',
            operasi: 'operasi',
            selesai: 'selesai',
            pilih: 'pilih',
            jamMulaiDisabled: false,
            jamSelesaiDisabled: (this.jadwalDokterKhusus.FS_JAM_SELESAI == "Selesai")?true:false
        };
    },
    watch:{
        pickStatus(){
            if(this.pickStatus === 'libur'){
                this.form.status = '2';
                this.form.jamMulai = 'Libur';
                this.form.jamSelesai = 'Libur';

                this.jamMulaiDisabled = true;
                this.jamSelesaiDisabled = true;
            }else if(this.pickStatus === 'operasi'){
                this.form.status = '3';
                this.form.jamMulai = 'Operasi';
                this.form.jamSelesai = 'Operasi';

                this.jamMulaiDisabled = true;
                this.jamSelesaiDisabled = true;
            }else if(this.pickStatus === 'selesai'){
                this.form.status = this.jadwalDokterKhusus.FS_STATUS;
                this.form.jamMulai = '';
                this.form.jamSelesai = 'Selesai';

                this.jamMulaiDisabled = false;
                this.jamSelesaiDisabled = true;
            }else{
                this.form.status = this.jadwalDokterKhusus.FS_STATUS;
                this.form.jamMulai = '';
                this.form.jamSelesai = '';

                this.jamMulaiDisabled = false;
                this.jamSelesaiDisabled = false;
            }
            console.log(this.form.status);
        }
    },
    components: {
        Link,
        TextInput,
        FlashMessage,
        SelectInput,
        TimeInput,
    },
    props: {
        poli: Object,
        dokter: Object,
        hari: Object,
        jadwalDokterKhusus: Object
    },
    layout: LayoutAdmin,
    methods: {
        getInitialState(){
            var initialPickStatus = '';
            var initialJamMulai = '';
            var initialJamSelesai = '';
            switch (this.jadwalDokterKhusus.FS_JAM_SELESAI) {
                case 'Selesai':
                    initialPickStatus =  'selesai';
                    initialJamMulai = this.jadwalDokterKhusus.FS_JAM_MULAI;
                    initialJamSelesai = 'Selesai';
                    break;
                case 'Libur':
                    initialPickStatus =  'libur';
                    initialJamMulai = 'Libur';
                    initialJamSelesai = 'Libur';
                    break;
                case 'Operasi':
                    initialPickStatus =  'operasi';
                    initialJamMulai = 'Operasi';
                    initialJamSelesai = 'Operasi';
                    break;
                default:
                    initialPickStatus = 'pilih'
                    initialJamMulai = this.jadwalDokterKhusus.FS_JAM_MULAI;
                    initialJamSelesai = this.jadwalDokterKhusus.FS_JAM_SELESAI;
                    break;
            }
            return {
                initialPickStatus,
                initialJamMulai,
                initialJamSelesai
            };
        },
        update() {
            const confirm = window.confirm(
                "Yakin menyimpan data jadwal dokter khusus?"
            );
            if (confirm == 1) {
                console.log(this.form);
                this.form.put(`/admin/jadwal_dokter_khusus/${this.jadwalDokterKhusus.FS_KD_LAYANAN+'-'+this.jadwalDokterKhusus.FS_KD_DOKTER+'-'+this.jadwalDokterKhusus.FS_KD_HARI}`, { preserveScroll: true });
            }
        },
        destroy() {
            const confirm = window.confirm('Yakin akan menghapus data jadwal dokter khusus tersebut?')
            if (confirm==1) {
                this.form.status = 4;
                this.$inertia.delete(`/admin/jadwal_dokter_khusus/${this.hari.tgl}/${this.jadwalDokterKhusus.FS_KD_LAYANAN+'-'+this.jadwalDokterKhusus.FS_KD_DOKTER+'-'+this.jadwalDokterKhusus.FS_KD_HARI}`)
            }
        }
    },
};
</script>
